import React, { useState, useEffect } from "react";
import TreeView from "react-treeview";
import $ from "jquery";
import ReactStars from "react-rating-stars-component";
import "react-toastify/dist/ReactToastify.css";
import "react-treeview/react-treeview.css";
import "../../../../../assets/css/bootStrap/bootstrap.min.css"
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-image-lightbox/style.css";
import "video.js/dist/video-js.css";
import "../../../../../assets/css/overridestyles.css";

import {
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { ProfileService } from "../../../../../services/ProfileService";
import { JobService } from "../../../../../services/JobService";
import { Stringutility } from "../../../../../utilities/stringutility";
import { StorageValues } from "../../../../../constants/storageValues";
import { StorageService } from "../../../../../services/StorageService";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Constants } from "../../../../../constants/constantValues";
// import Button from "../../../../../buttoncomponent/StyledButton";

const Skills = (props) => {
  const [skillShow, setSkillShow] = useState(false);
  const [categories, setCategories] = useState([]);
  const [rating, setRating] = useState(0);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [modalRight, setModalRight] = useState(false);
  const [ModalLong, setModalLong] = useState(false);
  const [languageshow, setlanguageShow] = useState(true);

  const [candidateSkills, setCandidateSkills] = useState([]);
  const [skillSelectedList, setSkillSelectedList] = useState([]);
  const [ratingSpokenSelectedList, setRatingSpokenSelectedList] = useState([]);
  const [skillId, setSkillId] = useState("");
  const [skillName, setSkillName] = useState("");
  const [skillIds, setSkillIds] = useState([]);
  const [jobSkillLevels, setJobSkillLevels] = useState([]);
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);
  const [jobSkills, setJobSkills] = useState([]);
  const [candidatejobSkillsValues, setCandidateJobSkillsValues] = useState([]);
  const [selectedSkillId, setSelectedSkillId] = useState("");
  const [candidateTotSkills, setCandidateTotSkills] = useState([]);
  const [profile, setProfile] = useState("");

  useEffect(() => {
    let profile=StorageService.getFromLocalStorage(StorageValues.PROFILE);
    if (!Stringutility.isNullOrEmpty(profile)) {
      setProfile(profile);
    }
    setJobSkills(handleJobSkills(props.skills));

    if (!Stringutility.isNullOrEmpty(window.localStorage.getItem("enumsLists"))) {
      var enumsLists = JSON.parse(window.localStorage.getItem("enumsLists"));
      if (enumsLists.jobSkillLevels !== null) {
        setJobSkillLevels(enumsLists.jobSkillLevels);
      }
    }
    getTotalSkillList();
    getCandidateSkillList();
  }, []);

  const getTotalSkillList = () => {
    JobService.getSkills().then((response) => {
      try {
        var skillDetails = response.data;
        if (skillDetails != null) {
          setCategories(skillDetails.indlist);
          setFilteredSkills(skillDetails.indlist);
          skillDetails.indlist.length > 0 &&
            skillDetails.indlist.map((industrydetails, index) => {
              industrydetails.categories.length > 0 &&
                industrydetails.categories.map((category, index) => {
                  category.skills.length > 0 &&
                    category.skills.map((skill, indexval) => {
                      category.skills[indexval].rating = 0;
                      category.skills[indexval].isDisabled = false;
                    });
                });
            });

          setCategories(skillDetails.indlist);
          setFilteredSkills(skillDetails.indlist);
        }
      } catch (err) {
        console.error("getSkills" + JSON.stringify(err));
      }
    });
  };

  const getCandidateSkillList = () => {
    ProfileService.getProfileSkills().then((response) => {
      try {
        if (response.data != null) {
          let skillsList = response.data.skills;
          if (skillsList.length > 0) {
            setCandidateTotSkills(skillsList);

            if (props.candidateSkills == undefined) {
              setCandidateSkills(skillsList);
              return;
            }
            props.candidateSkills(skillsList);
            let candidateJobSkills = matchJobSkills(props.skills, skillsList);
            let candidateJobSkillsList = [...candidateJobSkills];
            if (candidateJobSkillsList.length > 0) {
              props.candidateJobSkills(candidateJobSkillsList);
              setJobSkills(candidateJobSkillsList);
              skillsList.map((skill) => {
                candidateJobSkillsList.push(skill);
              });
              setCandidateSkills([]);
              setCandidateSkills(candidateJobSkillsList);
            } else {
              props.candidateJobSkills([]);
              setCandidateSkills([]);
              setCandidateSkills(skillsList);
            }
          } else {
            setCandidateTotSkills([]);
            if (props.skills == undefined) {
              return;
            }
            let candidateJobSkills = matchJobSkills(props.skills, skillsList);
            setCandidateSkills(candidateJobSkills);
            setJobSkills(handleJobSkills(props.skills));
            if (props.candidateJobSkills == undefined) {
              return;
            }
            props.candidateJobSkills(candidateJobSkills);
          }
        }
      } catch (err) {
        console.error("getProfileSkills" + JSON.stringify(err));
      }
    });
  };

  const updateCandidateSkills = (candidateSkillList, totalSkills) => {
    var updatedList = [];
    const selectedSkillsList = [...totalSkills];
    const selectedRatingList = [];
    let candidateSelectedSkills = [];

    if (selectedSkillsList.length > 0) {
      selectedSkillsList.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                if (candidateSkillList.length > 0) {
                  const isFound = candidateSkillList.some((element) => {
                    if (element.skillId === skill.skillId) {
                      return true;
                    }
                    return false;
                  });

                  if (isFound) {
                    for (let j = 0; j < candidateSkillList.length; j++) {
                      let candidateSkillId = candidateSkillList[j].skillId;
                      let candidateCategoryId =
                        candidateSkillList[j].categoryId;
                      let candidateSkillRating = candidateSkillList[j].rating;

                      if (candidateSkillId == skill.skillId) {
                        if (candidateCategoryId == category.id) {
                          category.skills[indexval].isDisabled = false;
                          category.skills[indexval].rating =
                            candidateSkillRating;

                          const skillDetails = {
                            skillId: candidateSkillId,
                            categoryId: category.id,
                          };
                          updatedList.push(skillDetails);

                          let uniqueId = category.id + "_" + skill.skillId;
                          selectedRatingList.push({
                            skillId: skill.skillId,
                            rating: candidateSkillRating,
                            categoryId: category.id,
                            uniqueId: uniqueId,
                          });

                          candidateSelectedSkills.push({
                            skillId: skill.skillId,
                            skillLevel: $(
                              "#" + skill.skillId + "_skillLevel"
                            ).val(),
                            rating: candidateSkillRating,
                          });
                        } else {
                          category.skills[indexval].isDisabled = true;
                        }
                      }
                    }
                  } else {
                    category.skills[indexval].isDisabled = false;
                  }
                }
              });
          });
      });
      setSelectedSkills(candidateSelectedSkills);
      setRatingSpokenSelectedList(selectedRatingList);
      setSkillSelectedList(updatedList);
      setFilteredSkills(selectedSkillsList);
    } else {
      setSkillSelectedList([]);
      setFilteredSkills(selectedSkillsList);
    }
  };

  const handleJobSkills = (jobSkills) => {
    let candidateJobSkills = [];
    if (jobSkills == null) {
      return candidateJobSkills;
    }

    if (jobSkills == undefined) {
      return candidateJobSkills;
    }

    let jobSkillDetails = jobSkills;
    if (jobSkillDetails.length > 0) {
      jobSkillDetails.map((skill) => {
        skill.rating = 0;
      });
      candidateJobSkills = [...jobSkillDetails];
    }
    return candidateJobSkills;
  };

  const matchJobSkills = (jobSkills, candidateskills) => {
    let candidateJobSkills = [];

    let jobSkillDetails = jobSkills;
    if (jobSkillDetails !== null || jobSkillDetails !== undefined) {
      if (jobSkillDetails.length > 0) {
        const data = [];
        jobSkillDetails.map((skill) => {
          skill.rating = 0;
          if (sessionStorage.getItem("removedList") !== null) {
            var retrievedData = sessionStorage.getItem("removedList");
            var removedList = JSON.parse(retrievedData);
            if (removedList.length > 0) {
              const isFound = removedList.some((element, index) => {
                if (element === skill.skillId) {
                  return true;
                }
                return false;
              });
              if (!isFound) {
                data.push(skill);
              }
            }
          } else {
            data.push(skill);
          }
        });

        const updatedJobDetails = [];
        for (let i = 0; i < data.length; i++) {
          let skill = data[i];
          if (candidateskills.length > 0) {
            const isFound = candidateskills.some((element, index) => {
              if (element.skillId === skill.skillId) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              updatedJobDetails.push(skill);
            }
          } else {
            updatedJobDetails.push(skill);
          }
        }
        candidateJobSkills = [...updatedJobDetails];
      }
    }
    return candidateJobSkills;
  };

  const handleCheck = (event, softSkills, categoryId) => {
    var updatedList = [...skillSelectedList];
    var selectedSkillId = softSkills.skillId;

    var uniqueId = categoryId + "_" + softSkills.skillId;

    if (event.target.checked) {
      const skillDetails = {
        skillId: softSkills.skillId,
        categoryId: categoryId,
      };
      updatedList.push(skillDetails);
      const isFound = selectedSkills.some((element) => {
        if (softSkills.skillId === selectedSkills.skillId) {
          return true;
        }
        return false;
      });
      if (isFound) {
      } else {
        selectedSkills.push({
          skillId: softSkills.skillId,
          skillLevel: $("#" + softSkills.skillId + "_skillLevel").val(),
          rating: 0,
        });
        skillIds.push({
          skillId: softSkills.skillId,
        });
      }

      let selectedRatingList = [...ratingSpokenSelectedList];
      if (selectedRatingList.length > 0) {
        for (let i = 0; i < selectedRatingList.length; i++) {
          selectedRatingList[i].isRated = false;
          if (selectedRatingList[i].categoryId == categoryId) {
            if (selectedRatingList[i].uniqueId == uniqueId) {
              selectedRatingList[i].rating = 0;
            }
          }
        }
      }

      setRatingSpokenSelectedList(selectedRatingList);
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].categoryId == categoryId) {
          if (updatedList[i].skillId == softSkills.skillId) {
            updatedList.splice(i, 1);
            skillIds.splice(i, 1);
          }
        }
      }
      for (var i = 0; i < selectedSkills.length; i++) {
        if (selectedSkills[i].skillId == softSkills.skillId) {
          selectedSkills.splice(i, 1);
          break;
        }
      }

      const selectedRatingList = [...ratingSpokenSelectedList];
      if (selectedRatingList.length > 0) {
        for (let i = 0; i < selectedRatingList.length; i++) {
          if (selectedRatingList[i].categoryId == categoryId) {
            if (selectedRatingList[i].uniqueId == uniqueId) {
              selectedRatingList[i].rating = 0;
            }
          }
        }
      }
      setRatingSpokenSelectedList(selectedRatingList);
    }

    for (let i = 0; i < filteredSkills.length; i++) {
      let categories = filteredSkills[i].categories;
      if (categories.length > 0) {
        for (let j = 0; j < categories.length; j++) {
          let skillCategoryId = categories[j].id;
          let skills = categories[j].skills;
          if (skills.length > 0) {
            for (let k = 0; k < skills.length; k++) {
              if (skills[k].skillId == selectedSkillId) {
                if (skillCategoryId == categoryId) {
                  skills[k].isDisabled = false;
                } else {
                  if (event.target.checked) {
                    skills[k].isDisabled = true;
                  } else {
                    skills[k].isDisabled = false;
                  }
                }
              }
            }
          }
        }
      }
    }
    setSelectedSkills(selectedSkills);
    setSkillSelectedList(updatedList);
    setFilteredSkills(filteredSkills);
  };

  const ratingChanged = (newRating, id, categoryId) => {
    let skillRatingList = [...ratingSpokenSelectedList];
    if (skillRatingList.length > 0) {
      skillRatingList.map((skillRating) => {
        skillRating.isRated = false;
      });
    }

    var uniqueId = categoryId + "_" + id;
    setRating(newRating);
    for (var i = 0; i < selectedSkills.length; i++) {
      if (selectedSkills[i].skillId == id) {
        selectedSkills[i].rating = newRating;
        break;
      }
    }

    if (skillRatingList.length > 0) {
      const isFound = skillRatingList.some((element) => {
        if (element.categoryId === categoryId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        const isSkillFound = skillRatingList.some((element) => {
          if (element.uniqueId === uniqueId) {
            return true;
          }
          return false;
        });
        if (isSkillFound) {
          for (let i = 0; i < skillRatingList.length; i++) {
            if (skillRatingList[i].categoryId == categoryId) {
              if (skillRatingList[i].uniqueId == uniqueId) {
                skillRatingList[i].skillId = id;
                skillRatingList[i].rating = newRating;
                skillRatingList[i].uniqueId = categoryId + "" + id;
                skillRatingList[i].isRated = true;
              } else {
                skillRatingList[i].isRated = false;
              }
            }
          }
        } else {
          skillRatingList.push({
            skillId: id,
            rating: newRating,
            categoryId: categoryId,
            uniqueId: uniqueId,
            isRated: true,
          });
        }
      } else {
        skillRatingList.push({
          skillId: id,
          rating: newRating,
          categoryId: categoryId,
          uniqueId: uniqueId,
          isRated: true,
        });
      }
    } else {
      skillRatingList.push({
        skillId: id,
        rating: newRating,
        categoryId: categoryId,
        uniqueId: uniqueId,
        isRated: true,
      });
    }
    setRatingSpokenSelectedList(skillRatingList);
  };

  const updateSkills = () => {
    if (selectedSkills.length > 0) {
      const skillData = [];

      selectedSkills.map((skill) => {
        for (let j = 0; j < ratingSpokenSelectedList.length; j++) {
          if (ratingSpokenSelectedList[j].skillId == skill.skillId) {
            skill.rating = ratingSpokenSelectedList[j].rating;
          }
        }

        if (skillData.length > 0) {
          const isFound = skillData.some((element) => {
            if (element.skillId === skill.skillId) {
              return true;
            }
            return false;
          });

          if (!isFound) {
            skillData.push({
              skillId: skill.skillId,
              rating: skill.rating,
            });
          }
        } else {
          skillData.push({
            skillId: skill.skillId,
            rating: skill.rating,
          });
        }
      });

      for (let i = 0; i < skillData.length; i++) {
        if (skillData[i].rating != null) {
          if (skillData[i].rating == 0) {
            Stringutility.showErrorMessage(Constants.giveRatingForSkills);
            return;
          }
        } else {
          Stringutility.showErrorMessage(Constants.giveRatingForSkills);
          return;
        }
      }
      const skillObj = {
        skills: skillData,
      };
      setSaveBtnEnabled(true);
      ProfileService.updateSkill(skillObj).then((response) => {
        setSaveBtnEnabled(false);
        try {
          setModalRight(false);
          setCandidateSkills([]);
          getCandidateSkillList();
        } catch (err) {
          console.error("updateSkill" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showErrorMessage(Constants.selectSkill)
    }
  };

  const updateJobSkills = (skillId, skillRating) => {
    if (skillRating == 0) {
      Stringutility.showErrorMessage(Constants.giveRatingForSkill)
    } else {
      const skillData = [];
      skillData.push({
        skillId: skillId,
        rating: skillRating,
      });
      const skillObj = {
        skills: skillData,
      };
      // setSaveBtnEnabled(true);
      ProfileService.updateSkill(skillObj).then((response) => {
        setSaveBtnEnabled(false);
        try {
          Stringutility.showSuccessMessage(Constants.skillUpdatedSuccessfully)
          setCandidateSkills([]);
          getCandidateSkillList();
        } catch (err) {
          console.error("updateSkill" + JSON.stringify(err));
        }
      });
    }
  };

  const updateCandidateSkillRating = (candidateSkills) => {
    if (candidateSkills.length > 0) {
      const skillData = [];
      candidateSkills.map((skill) => {
        if (skillData.length > 0) {
          const isFound = skillData.some((element) => {
            if (element.skillId === skill.skillId) {
              return true;
            }
            return false;
          });

          if (!isFound) {
            skillData.push({
              skillId: skill.skillId,
              rating: skill.rating,
            });
          }
        } else {
          skillData.push({
            skillId: skill.skillId,
            rating: skill.rating,
          });
        }
      });

      for (let i = 0; i < skillData.length; i++) {
        if (skillData[i].rating != null) {
          if (skillData[i].rating == 0) {
            Stringutility.showErrorMessage(Constants.giveRatingForSkillsOrDeleted)
            return;
          }
        } else {
          Stringutility.showErrorMessage(Constants.giveRatingForSkillsOrDeleted)
          return;
        }
      }
      const skillObj = {
        skills: skillData,
      };
      ProfileService.updateSkill(skillObj).then((response) => {
        setSaveBtnEnabled(false);        
      });
    } else {
      Stringutility.showErrorMessage(Constants.selectSkill);
    }
  };

  const searchItems = (searchValue) => {
    setlanguageShow(true);
    if (searchValue !== "") {
      if (searchValue.length >= 3) {
        JobService.searchSkill(searchValue).then((response) => {
          try {
            if (response.data != null) {
              setFilteredSkills(response.data.indlist);
              response.data.indlist.length > 0 &&
                response.data.indlist.map((industrydetails, index) => {
                  industrydetails.categories.length > 0 &&
                    industrydetails.categories.map((category, index) => {
                      category.skills.length > 0 &&
                        category.skills.map((skill, indexval) => {
                          category.skills[indexval].rating = 0;
                          category.skills[indexval].isDisabled = false;
                        });
                    });
                });
              //setFilteredSkills(response.data.indlist);
              updateSkillDetails(response.data.indlist);
              setSkillShow(true);
            }
          } catch (err) {
            console.error("searchSkill" + JSON.stringify(err));
          }
        });
      } else {
        categories.length > 0 &&
          categories.map((industrydetails, index) => {
            industrydetails.categories.length > 0 &&
              industrydetails.categories.map((category, index) => {
                category.skills.length > 0 &&
                  category.skills.map((skill, indexval) => {
                    ratingSpokenSelectedList.length > 0 &&
                      ratingSpokenSelectedList.map((rateskill, indexval1) => {
                        if (rateskill.skillId == skill.skillId) {
                          category.skills[indexval].rating = rateskill.rating;
                        }
                      });
                  });
              });
          });
        setFilteredSkills(categories);
      }
    } else {
      categories.length > 0 &&
        categories.map((industrydetails, index) => {
          industrydetails.categories.length > 0 &&
            industrydetails.categories.map((category, index) => {
              category.skills.length > 0 &&
                category.skills.map((skill, indexval) => {
                  ratingSpokenSelectedList.length > 0 &&
                    ratingSpokenSelectedList.map((rateskill, indexval1) => {
                      if (rateskill.skillId == skill.skillId) {
                        category.skills[indexval].rating = rateskill.rating;
                      }
                    });
                });
            });
        });

      setFilteredSkills(categories);
    }
  };

  const updateSkillDetails = (skillsList) => {
    const selectedSkillsList = [...skillsList];
    if (selectedSkillsList.length > 0) {
      selectedSkillsList.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                category.skills[indexval].isDisabled = false;
                ratingSpokenSelectedList.length > 0 &&
                  ratingSpokenSelectedList.map((rateskill, indexval1) => {
                    if (rateskill.skillId == skill.skillId) {
                      category.skills[indexval].rating = rateskill.rating;
                    }
                  });
                // // categoryId
                skillSelectedList.length > 0 &&
                  skillSelectedList.map((selectedSkill, index) => {
                    if (selectedSkill.skillId == skill.skillId) {
                      if (selectedSkill.categoryId == category.id) {
                        //   category.skills[indexval].isDisabled=true
                      } else {
                        category.skills[indexval].isDisabled = true;
                      }
                    }
                    // if(sele)
                  });
              });
          });
      });
      setFilteredSkills(selectedSkillsList);
    } else {
      setFilteredSkills(selectedSkillsList);
    }
  };

  const onAddSkills = () => {
    resetSkillsListDetails();
    setModalRight(true);
    setSkillIds([]);
    setlanguageShow(true);
  };

  const resetSkillsList = () => {
    categories.length > 0 &&
      categories.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                category.skills[indexval].isDisabled = false;
              });
          });
      });
    setCategories(categories);
    setFilteredSkills(categories);
  };

  const resetSkillsListDetails = () => {
    let selectedcandidateTotSkills = [...candidateTotSkills];
    categories.length > 0 &&
      categories.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            if (category.skills.length > 0) {
              selectedcandidateTotSkills.map((sSkill, sIndex) => {
                const isFound = category.skills.some((element) => {
                  if (element.skillId === sSkill.skillId) {
                    return true;
                  }
                  return false;
                });
                if (isFound) {
                  sSkill.categoryId = category.id;
                }
              });
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                category.skills[indexval].isDisabled = false;
              });
            }
          });
      });
    setCategories(categories);
    updateCandidateSkills(candidateTotSkills, categories);
  };

  const seeFullList = () => {
    setlanguageShow((prev) => !prev);
    setFilteredSkills(categories);
  };

  const handledeletesoftskill = (id, name, skillId) => {
    setSkillId(id);
    setSkillName(name);
    // setModalLong(true)
    setSelectedSkillId(skillId);
    removeSkillDetails(id);
  };

  const removeSkillDetails = (id) => {
    if (candidateTotSkills.length > 0) {
      ProfileService.deleteCandidateSkill(id).then((response) => {
        try {
          // toast.success('Skill deleted successfully')
          //  updateDetails()
          setCandidateSkills([]);
          getCandidateSkillList();
          setModalLong(false);
        } catch (err) {
          console.error("deleteCandidateSkill" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showSuccessMessage(Constants.skillDeleted);
      updateDetails();
      setCandidateSkills([]);
      getCandidateSkillList();
      setModalLong(false);
    }
  };

  const updateDetails = () => {
    const skills = [];
    if (sessionStorage.getItem("removedList") !== null) {
      var retrievedData = sessionStorage.getItem("removedList");
      var removedList = JSON.parse(retrievedData);
      if (removedList.length > 0) {
        const data = [...removedList];
        const isFound = data.some((element) => {
          if (element === selectedSkillId) {
            return true;
          }
          return false;
        });
        if (!isFound) {
          data.push(selectedSkillId);
          sessionStorage.setItem("removedList", JSON.stringify(data));
        }
      } else {
        skills.push(selectedSkillId);
        sessionStorage.setItem("removedList", JSON.stringify(skills));
      }
    } else {
      skills.push(selectedSkillId);
      sessionStorage.setItem("removedList", JSON.stringify(skills));
    }
  };

  const back = () => {
    setModalLong(false);
  };

  const setRatingValue = (skillId, categoryId) => {
    var uniqueId = categoryId + "_" + skillId;
    let ratingValue = 0;
    if (ratingSpokenSelectedList.length > 0) {
      const isFound = ratingSpokenSelectedList.some((element) => {
        if (element.categoryId === categoryId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        const isSkillFound = ratingSpokenSelectedList.some((element) => {
          if (element.uniqueId === uniqueId) {
            return true;
          }
          return false;
        });
        if (isSkillFound) {
          for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
            if (ratingSpokenSelectedList[i].uniqueId == uniqueId) {
              return ratingSpokenSelectedList[i].rating;
            }
          }
        } else {
          ratingValue = 0;
        }
      } else {
        ratingValue = 0;
      }
    } else {
      ratingValue = 0;
    }
  };

  const checkSkillStatus = (skillId, categoryId) => {
    var isSkillSelected = false;
    if (skillSelectedList.length > 0) {
      for (let i = 0; i < skillSelectedList.length; i++) {
        // if (skillSelectedList[i].categoryId == categoryId) {
        if (skillSelectedList[i].skillId == skillId) {
          isSkillSelected = true;
        }
        // }
      }
    }
    return isSkillSelected;
  };

  const candidateSkillsratingChanged = (newRating, skillId, index) => {
    let skillsList=[...candidateSkills];
    if(skillsList.length>0){
      skillsList.map(skill=>{
        if(skill.skillId==skillId){
          skill.rating=newRating;
          skill.isRated=true;
        }else{
          skill.isRated=false;
        }
      })
      setCandidateSkills(skillsList);
      updateCandidateSkillRating(skillsList)
    }
  };

  const dailogerating = (skillId, categoryId) => {
    var uniqueId = categoryId + "_" + skillId;
    let ratingValue = 0;
    let isRated = false;
    if (ratingSpokenSelectedList.length > 0) {
      for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
        if (ratingSpokenSelectedList[i].categoryId == categoryId) {
          if (ratingSpokenSelectedList[i].skillId == skillId) {
            ratingValue = ratingSpokenSelectedList[i].rating;
            //return showRatingFlavor(ratingValue);
            isRated = ratingSpokenSelectedList[i].isRated;
          }
        }
      }
    } else {
      ratingValue = 0;
    }

    if (isRated) {
      if (ratingValue == 1) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Beginner";
      } else if (ratingValue == 2) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Intermediate";
      } else if (ratingValue == 3) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Proficient";
      } else if (ratingValue == 4) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Advanced";
      } else if (ratingValue == 5) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Expert";
      }
    }
  };

  const checkSkillRatingStatus = (skillId, categoryId) => {
    var isSkillSelected = false;
    if (skillSelectedList.length > 0) {
      for (let i = 0; i < skillSelectedList.length; i++) {
        if (skillSelectedList[i].skillId == skillId) {
          if (skillSelectedList[i].categoryId == categoryId) {
            isSkillSelected = true;
          } else {
            isSkillSelected = false;
          }
        }
      }
    }
    return isSkillSelected;
  };

  const skillDailogerating = (skill) => {
    let skillId=skill.skillId
    if (candidateSkills.length > 0) {
      for (let i = 0; i < candidateSkills.length; i++) {
        if (candidateSkills[i].skillId == skillId) {
          let ratingValue = candidateSkills[i].rating;
          let isRated = candidateSkills[i].isRated;
          if (isRated) {
            candidateSkills[i].isRated=false;
            if (ratingValue == 1) {
              $("#" + skillId + "skillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Beginner";
            } else if (ratingValue == 2) {
              $("#" + skillId + "skillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Intermediate";
            } else if (ratingValue == 3) {
              $("#" + skillId + "skillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Proficient";
            } else if (ratingValue == 4) {
              $("#" + skillId + "skillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Advanced";
            } else if (ratingValue == 5) {
              $("#" + skillId + "skillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Expert";
            }
          }
        }
      }
    } 
  };

  return (
    <div className="Container-box ">
      <div>
        <div>
          <Modal
            scrollable={true}
            isOpen={modalRight}
            toggle={() => setModalRight(!modalRight)}
            wrapClassName="modal-right"
            className="skill-model-width scroll t-modal-dialog"
          >
            <ModalHeader>
              <div>
                <strong>Add and rate your skills</strong>
              </div>
            </ModalHeader>
            <ModalBody className="labelSize">
              <div className="row mb-3">
                <div className="col-sm-12">
                  <Input
                    type="text"
                    icon="search"
                    placeholder="Search for skills"
                    onChange={(e) => searchItems(e.target.value)}
                  />
                </div>
              </div>
              {languageshow && (
                <>
                  {filteredSkills.length > 0 &&
                    filteredSkills.map((industrydetails, index) => {
                      return (
                        <div key={index}>
                          <TreeView
                            nodeLabel={industrydetails.industry}
                            defaultCollapsed={false}
                            className="treeViewIconSize"
                          >
                            <div className="col ">
                              {industrydetails.categories.length > 0 &&
                                industrydetails.categories.map(
                                  (category, index) => {
                                    return (
                                      <div key={index}>
                                        {category.name == null ||
                                        category.name == " " ? (
                                          <div>
                                            {category.skills.length > 0 &&
                                              category.skills.map(
                                                (skill, skillIndex) => {
                                                  return (
                                                    <div key={skillIndex}>
                                                      <div className="col-12">
                                                        <div className="row">
                                                          <div className="col-sm-12 mt-2">
                                                            <label
                                                              className={
                                                                skill.isDisabled
                                                                  ? "terms d-checkbox"
                                                                  : "terms"
                                                              }
                                                            >
                                                              <input
                                                                id="skill"
                                                                type="checkbox"
                                                                disabled={
                                                                  skill.isDisabled
                                                                }
                                                                className="input_skill"
                                                                checked={checkSkillStatus(
                                                                  skill.skillId,
                                                                  category.id
                                                                )}
                                                                onChange={(e) =>
                                                                  handleCheck(
                                                                    e,
                                                                    skill,
                                                                    category.id
                                                                  )
                                                                }
                                                              />{" "}
                                                              {skill.name}
                                                            </label>
                                                          </div>
                                                          {checkSkillRatingStatus(
                                                            skill.skillId,
                                                            category.id
                                                          ) ? (
                                                            <>
                                                              <div className="ml-0 mr-0 col-xl-4 col-6 t-pad-star">
                                                                <div className="text-center items-center justify-center inline-block my-2 t-max-star-wid">
                                                                  <Row>
                                                                    {" "}
                                                                    <span>
                                                                      <Card className="star_bg_color col t-status-pad-star">
                                                                        <ReactStars
                                                                          count={
                                                                            5
                                                                          }
                                                                          size={
                                                                            16
                                                                          }
                                                                          activeColor="rgb(255, 188, 59)"
                                                                          id={
                                                                            skill.skillId +
                                                                            "_rating"
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            ratingChanged(
                                                                              e,
                                                                              skill.skillId,
                                                                              category.id
                                                                            )
                                                                          }
                                                                          value={setRatingValue(
                                                                            skill.skillId,
                                                                            category.id
                                                                          )}
                                                                        />
                                                                      </Card>
                                                                    </span>{" "}
                                                                    &nbsp;&nbsp;
                                                                    <span
                                                                      id={
                                                                        skill.skillId +
                                                                        category.id +
                                                                        "ratingMessage"
                                                                      }
                                                                      className="t-status-size t-status-pad-st"
                                                                    >
                                                                      {dailogerating(
                                                                        skill.skillId,
                                                                        category.id
                                                                      )}
                                                                    </span>
                                                                  </Row>

                                                                  <div></div>
                                                                </div>
                                                              </div>
                                                            </>
                                                          ) : (
                                                            <></>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                          </div>
                                        ) : (
                                          <div>
                                            <TreeView
                                              nodeLabel={category.name}
                                              defaultCollapsed={false}
                                              className="treeViewIconSize t-fold-pad"
                                            >
                                              <div>
                                                {category.skills.length > 0 &&
                                                  category.skills.map(
                                                    (skill, catSkillIndex) => {
                                                      return (
                                                        <div
                                                          key={catSkillIndex}
                                                        >
                                                          <div className="row">
                                                            <div className="col-xl-6 col-6 t-fold-lab">
                                                              <label
                                                                className={
                                                                  skill.isDisabled
                                                                    ? "terms d-checkbox"
                                                                    : "terms"
                                                                }
                                                              >
                                                                <input
                                                                  id="skill"
                                                                  type="checkbox"
                                                                  className="input_skill"
                                                                  disabled={
                                                                    skill.isDisabled
                                                                  }
                                                                  checked={checkSkillStatus(
                                                                    skill.skillId,
                                                                    category.id
                                                                  )}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleCheck(
                                                                      e,
                                                                      skill,
                                                                      category.id
                                                                    )
                                                                  }
                                                                />{" "}
                                                                {skill.name}
                                                              </label>
                                                            </div>

                                                            {checkSkillRatingStatus(
                                                              skill.skillId,
                                                              category.id
                                                            ) ? (
                                                              <>
                                                                <div className="ml-0 mr-0 col-xl-4 col-6 t-pad-star">
                                                                  <div className="text-center items-center justify-center inline-block my-2 t-max-star-wid">
                                                                    <Row>
                                                                      {" "}
                                                                      <span>
                                                                        <Card className="star_bg_color col t-status-pad-star">
                                                                          <ReactStars
                                                                            count={
                                                                              5
                                                                            }
                                                                            size={
                                                                              16
                                                                            }
                                                                            activeColor="rgb(255, 188, 59)"
                                                                            id={
                                                                              skill.skillId +
                                                                              "_rating"
                                                                            }
                                                                            onChange={(
                                                                              e
                                                                            ) =>
                                                                              ratingChanged(
                                                                                e,
                                                                                skill.skillId,
                                                                                category.id
                                                                              )
                                                                            }
                                                                            value={setRatingValue(
                                                                              skill.skillId,
                                                                              category.id
                                                                            )}
                                                                          />
                                                                        </Card>
                                                                      </span>{" "}
                                                                      &nbsp;&nbsp;
                                                                      <span
                                                                        id={
                                                                          skill.skillId +
                                                                          category.id +
                                                                          "ratingMessage"
                                                                        }
                                                                        className="t-status-size t-status-pad-st"
                                                                      >
                                                                        {dailogerating(
                                                                          skill.skillId,
                                                                          category.id
                                                                        )}
                                                                      </span>
                                                                    </Row>

                                                                    <div></div>
                                                                  </div>
                                                                </div>
                                                              </>
                                                            ) : (
                                                              <></>
                                                            )}
                                                          </div>{" "}
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                              </div>
                                            </TreeView>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </TreeView>
                        </div>
                      );
                    })}
                  {filteredSkills.length == 0 && (
                    <div className="t-nodata">
                      <strong>Skill not found</strong>
                    </div>
                  )}
                </>
              )}
            </ModalBody>
            <ModalFooter className="t-modal-footer-btn">
              <TeamanicsButton
                onClick={() => setModalRight(false)}
              >
                Cancel
              </TeamanicsButton>
              <TeamanicsButton
                onClick={updateSkills}
                disabled={saveBtnEnabled}
              >
                Save
              </TeamanicsButton>{" "}
            </ModalFooter>
          </Modal>
        </div>

        <Card className="mt-4 bg-primary-white min-sm:rounded-xl pt-12 mb-8 p-3">
          <CardBody className="t-body-padding[0px]">
            <div className="skill-header">
              <div className="profile-card-title  row">
                <div className="col-sm-6">
                  <label>
                    <strong>Skills</strong>
                  </label>
                </div>
                {candidateSkills.length > 1 ? (
                  <>
                    <div className="col-sm-6 t-button-flex-end ">
                      <TeamanicsButton
                        onClick={onAddSkills}
                      >
                        Add more skills
                      </TeamanicsButton>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-sm-6 t-button-flex-end ">
                      <TeamanicsButton
                        onClick={onAddSkills}
                      >
                        Add skills
                      </TeamanicsButton>
                    </div>
                  </>
                )}
              </div>
              <p>
                {" "}
                Give 5 stars only on your top skills. Too many 5 stars hide your
                strengths and do not appear credible.
              </p>
            </div>

            {candidateSkills.length > 0 && (
              <>
                <div className="horizontal_line mt-1 mb-3" />
                {candidateSkills.map((skill, index) => {
                  return (
                    <div className=" mt-1" key={index}>
                      <Row>
                        <Colxx xxs="12">
                          <Form>
                            <Row>
                              <div className="col-10">
                                <div className="row">
                                  <div className="col-sm-6">
                                    <Label>{skill.name}</Label>
                                  </div>
                                  <div className="col-lg-4 ml-3">
                                    <div className="text-center items-center justify-center inline-block my-2">
                                      <div className="text-center items-center justify-center inline-block my-2 t-max-star-wid">
                                        <Row>
                                          {" "}
                                          <span>
                                            <Card className="star_bg_color col-sm-12  ">
                                              <ReactStars
                                                count={5}
                                                size={16}
                                                value={skill.rating}
                                                // edit={isRatingEditable()}
                                                activeColor="rgb(255, 188, 59)"
                                                id={skill.id + "_rating"}
                                                onChange={(e) =>
                                                  candidateSkillsratingChanged(
                                                    e,
                                                    skill.skillId,
                                                    index
                                                  )
                                                }
                                              ></ReactStars>
                                            </Card>
                                          </span>
                                          <span
                                            id={
                                              skill.skillId +
                                              "skillRatingMessage"
                                            }
                                            className="t-status-size ml-3"
                                          >
                                            {skillDailogerating(skill)}
                                            {/* {dailogerating(
                                          skill.skillId,
                                          category.id
                                        )} */}
                                          </span>
                                        </Row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-2 mt-1">
                                <span to="">
                                  <i
                                    className="simple-icon-trash edit-copyiconsize arrow-icon-color emp_icon"
                                    type="button"
                                    title="Delete Skill"
                                    color="black"
                                    onClick={() =>
                                      handledeletesoftskill(
                                        skill.id,
                                        skill.name,
                                        skill.skillId
                                      )
                                    }
                                  />
                                </span>
                              </div>
                            </Row>
                          </Form>
                        </Colxx>
                      </Row>
                    </div>
                  );
                })}
              </>
            )}
          </CardBody>
        </Card>
      </div>
      <Modal
        id="exampleModal"
        isOpen={ModalLong}
        toggle={() => setModalLong(!ModalLong)}
        twrapClassName="modal-right"
        className="file-model-width"
        aria-hidden="true"
      >
        <ModalHeader>
          <div>
            <label className="modal-title" id="exampleModalLabel">
              <strong>Delete skill</strong>
            </label>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="modal-body">
            <label>Do you want to delete {skillName} skill?</label>
          </div>
        </ModalBody>

        <ModalFooter className="model-button ">
          <div>
            <TeamanicsButton color="primary" outline data-dismiss="modal" onClick={back}>
              Close
            </TeamanicsButton>{" "}
            <TeamanicsButton
              color="primary"
              outline
              data-dismiss="modal"
              onClick={() => {
                removeSkillDetails();
              }}
            >
              Delete
            </TeamanicsButton>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Skills;
